import { DateOrTimeView } from "@mui/x-date-pickers";
import {
  CheckboxIcon,
  InputIcon,
  PictureIcon,
  RadioIcon,
  SignatureIcon,
  SubTitleIcon,
  TextIcon,
  TitleIcon,
  VideoIcon,
} from "./Icons";

export const IconMap: any = {
  title: TitleIcon,
  subtitle: SubTitleIcon,
  text: TextIcon,
  checkbox: CheckboxIcon,
  signature: SignatureIcon,
  picture: PictureIcon,
  input: InputIcon,
  radio: RadioIcon,
  video: VideoIcon,
};

export const ConsentLabelMap: any = {
  title: "Title",
  subtitle: "Sub Title",
  text: "Text/Statement",
  checkbox: "Checkbox",
  signature: "Signature",
  picture: "Picture",
  input: "Input",
  radio: "Multiple Choice",
  video: "Video",
};

export const blockTypes = [
  {
    key: "1",
    title: "Title",
    type: "title",
    icon: IconMap["title"],
  },
  {
    key: "2",
    title: "Sub Title",
    type: "subtitle",
    icon: IconMap["subtitle"],
  },
  {
    key: "3",
    title: "Text",
    type: "text",
    icon: IconMap["text"],
  },
  {
    key: "4",
    title: "Checkbox",
    type: "checkbox",
    icon: IconMap["checkbox"],
  },
  {
    key: "5",
    title: "Signature",
    type: "signature",
    icon: IconMap["signature"],
  },
  {
    key: "6",
    title: "Picture",
    type: "picture",
    icon: IconMap["picture"],
  },
  {
    key: "7",
    title: "Input",
    type: "input",
    icon: IconMap["input"],
  },
  {
    key: "8",
    title: "Multiple Choice",
    type: "radio",
    icon: IconMap["radio"],
  },
  {
    key: "9",
    title: "Video",
    type: "video",
    icon: IconMap["video"],
  },
];
export const luxonFormats: Record<string, string> = {
  "DD/MM/YYYY": "dd/MM/yyyy",
  "MM/DD/YYYY": "MM/dd/yyyy",
  "DD/MM/YYYY HH:mm": "dd/MM/yyyy HH:mm",
  "MM/DD/YYYY HH:mm": "MM/dd/yyyy HH:mm",
};

export const luxonViews: Record<string, DateOrTimeView[]> = {
  "DD/MM/YYYY": ["day", "month", "year"],
  "MM/DD/YYYY": ["day", "month", "year"],
  "DD/MM/YYYY HH:mm": ["day", "month", "year", "hours", "minutes"],
  "MM/DD/YYYY HH:mm": ["day", "month", "year", "hours", "minutes"],
};

const basicField = {
  label: "",
};
const checkboxField = {
  ...basicField,
  config: {
    optional: true,
  },
};
const signatureField = {
  ...basicField,
  config: {
    name: false,
    address: false,
    date: false,
  },
};
const pictureField = {
  label: "",
  resourceUrl: "",
  config: {
    position: "left",
  },
};

const textField = {
  ...basicField,
};

const inputField = {
  ...basicField,
  config: {
    optional: false,
    type: "text",
    position: "bottom",
    allowMultiline: false,
  },
};
const radioField = {
  ...basicField,
  config: {
    choices: [{ key: "", label: "" }],
  },
};
const videoField = {
  label: "",
  resourceUrl: "",
};

export const consentFieldMap = (type: string) => {
  switch (type) {
    case "title":
      return textField;
    case "subtitle":
      return textField;
    case "checkbox":
      return checkboxField;
    case "text":
      return textField;
    case "signature":
      return signatureField;
    case "picture":
      return pictureField;
    case "input":
      return inputField;
    case "radio":
      return radioField;
    case "video":
      return videoField;
    default:
      return {};
  }
};
